type UtmParamOptions = {
    utmSource?: UtmSource;
    utmMedium?: UtmMedium;
    utmCampaign?: UtmCampaign;
    utmContent?: UtmContent;
    utmId?: string;
};

type UtmSource = 'web_app' | 'cinema_website' | 'kino_fuehlst_du';
type UtmMedium = 'website';
type UtmCampaign = string | 'kino_fuehlst_du-2024';
type UtmContent = string;

/**
 * Adds UTM parameters to a URL, properly handling existing query parameters
 * @param url - The base URL to add UTM parameters to
 * @param options - UTM parameter options
 * @returns URL with UTM parameters appended, or null if URL is empty
 */
export function addUtmParams(url: string, options: UtmParamOptions): string {
    if (!(url.length > 0)) {
        return null;
    }

    const [baseUrl, queryString] = url.split('?');
    const existingParams = new URLSearchParams(queryString || '');

    // Generate UTM parameters
    const utmQueryString = utmParams(options);
    const newUtmParams = new URLSearchParams(utmQueryString);

    // Add UTM parameters to existing params (overwrites existing UTM parameters)
    newUtmParams.forEach((value, key) => {
        existingParams.set(key, value);
    });

    const finalQueryString = existingParams.toString();
    return baseUrl + (finalQueryString ? '?' + finalQueryString : '');
}

/**
 * Generates a URL query string with UTM parameters
 * @param options - UTM parameter options
 * @returns URL-encoded query string with UTM parameters
 */
export function utmParams(options: UtmParamOptions): string {
    const urlParams = new URLSearchParams();

    if (options.utmSource) {
        urlParams.set('utm_source', options.utmSource);
    }
    if (options.utmMedium) {
        urlParams.set('utm_medium', options.utmMedium);
    }
    if (options.utmCampaign) {
        urlParams.set('utm_campaign', options.utmCampaign);
    }
    if (options.utmContent) {
        urlParams.set('utm_content', options.utmContent);
    }
    if (options.utmId) {
        urlParams.set('utm_id', options.utmId);
    }

    return urlParams.toString();
}
